import { Grid } from '@mui/material';
import React from 'react';

import { RoutalPalette } from './Colors';
import { RoutalButton } from './RoutalButton';

interface CookiesBannerProps {
  message: string | React.ReactElement;
  closeText: string | React.ReactElement;
  onClose: (...args: any[]) => any;
}

export const RoutalCookiesBanner = ({ message, closeText, onClose }: CookiesBannerProps) => {
  return (
    <Grid
      container
      justifyContent="center"
      style={{
        position: `fixed`,
        bottom: `15px`,
        zIndex: 20000,
      }}
    >
      <Grid
        item
        container
        style={{
          backgroundColor: RoutalPalette.neutral60,
          borderRadius: `4px`,
          color: RoutalPalette.oldWhite,
          maxWidth: `1000px`,
          padding: `8px 32px`,
        }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item style={{ width: `calc(100% - 130px)`, color: `white`, fontSize: `14px` }}>
          {message}
        </Grid>
        <Grid item>
          <RoutalButton onClick={onClose}>{closeText}</RoutalButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
